import { useEffect } from 'react'

import { brandScale, type BrandStep } from '@/lib/brand/brandScale'
import { useAuthStore } from '@/stores/authStore'

const STEPS: BrandStep[] = [200, 300, 400, 500, 600, 700, 800, 900]

function rgbTriple(hex: string): string {
  const n = parseInt(hex.slice(1), 16)
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`
}

/**
 * Writes the signed-in company's palette onto `:root`, over the stylesheet's neutral defaults,
 * and removes it again on sign-out. An unusable colour leaves the defaults in place.
 */
export function useApplyBrand(): void {
  const brandColor = useAuthStore((state) => state.session?.workspace?.brandColor ?? null)

  useEffect(() => {
    const style = document.documentElement.style
    const scale = brandColor ? brandScale(brandColor) : null

    for (const step of STEPS) {
      if (scale) style.setProperty(`--palette-brand-${step}`, scale.steps[step])
      else style.removeProperty(`--palette-brand-${step}`)
    }
    if (scale) {
      style.setProperty('--palette-brand-accent', scale.accent)
      style.setProperty('--palette-brand-shadow', rgbTriple(scale.steps[700]))
    } else {
      style.removeProperty('--palette-brand-accent')
      style.removeProperty('--palette-brand-shadow')
    }
  }, [brandColor])
}
